import * as React from "react";
import {ImplementationType} from "../../models/OrganizationConfiguration/ImplementationType";

import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "@/components/ui/select";

interface ImplementationTypeSelectProps {
  value: ImplementationType | undefined;
  onChange: (value: ImplementationType | undefined) => void;
  required: boolean;
  disabled?: boolean;
}

const ImplementationTypeSelect: React.FC<ImplementationTypeSelectProps> = ({
  value,
  onChange,
  required,
  disabled = false,
}) => {
  return (
    <Select
      disabled={disabled}
      required={required}
      value={value || ""}
      onValueChange={(value) => onChange(value as ImplementationType)}
    >
      <SelectTrigger className="w-full">
        <SelectValue placeholder="Select implementation type" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={ImplementationType.AzureBlob}>Azure Blob</SelectItem>
        <SelectItem value={ImplementationType.Filevine}>Filevine</SelectItem>
        <SelectItem value={ImplementationType.Dropbox}>Dropbox</SelectItem>
        <SelectItem value={ImplementationType.Needles4}>Needles 4 - Sybase</SelectItem>
        <SelectItem value={ImplementationType.Needles5SQL}>Needles 5 - SQL</SelectItem>
        <SelectItem value={ImplementationType.Needles5Sybase}>Needles 5 - Sybase</SelectItem>
        <SelectItem value={ImplementationType.TrialWorks}>Trialworks</SelectItem>
        <SelectItem value={ImplementationType.DocsToNeos}>Docs To Neos</SelectItem>
      </SelectContent>
    </Select>
  );
};

export default ImplementationTypeSelect;
